module.exports = {
  quanLyDanhMuc: [
  //   {
  //   path: '/quan-ly-danh-muc/tham-quyen',
  //   name: 'Thẩm quyền giải quyết',
  //   key: 'THAMQUYENGIAIQUYET_LIETKE'
  // },
  {
    path: '/quan-ly-danh-muc/don-thu',
    name: 'Lĩnh vực đơn thư',
    key: 'LINHVUCDONTHU_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/linh-vuc-doi-tuong-thanh-tra',
    name: 'Lĩnh vực đối tượng thanh tra',
    key: 'LINHVUCDOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/doi-tuong-thanh-tra',
    name: 'Đối tượng thanh tra',
    key: 'DOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/nhom-doi-tuong-thanh-tra',
    name: 'Nhóm đối tượng thanh tra',
    key: 'NHOMDOITUONGTHANHTRA_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/danh-muc-video',
    name: 'Danh mục Video',
    key: 'DANHMUCVIDEO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/huong-dan-su-dung',
    name: 'Hướng dẫn sử dụng',
    key: 'HUONGDANSUDUNG_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/video',
    name: 'Video',
    key: 'VIDEO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/thanh-tra-trung-uong',
    name: 'Cơ quan TTTW tại Tỉnh',
    key: 'COQUANQUANLY_LIETKE'
  }],

  quanLyDonVi: [{
    path: '/quan-ly-danh-muc/cap-hanh-chinh',
    name: 'Cấp đơn vị hành chính',
    key: 'CAPDONVIHANHCHINH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/hanh-chinh',
    name: 'Đơn vị hành chính',
    key: 'DONVIHANHCHINH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/don-vi-ngoai-he-thong',
    name: 'Đơn vị ngoài hệ thống',
    key: 'DONVINGOAIHETHONG_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/loai-cap-co-quan',
    name: 'Loại cơ quan quản lý',
    key: 'LOAICOQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/cap-co-quan',
    name: 'Cấp cơ quan quản lý',
    key: 'CAPCOQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/co-quan',
    name: 'Cơ quan quản lý',
    key: 'COQUANQUANLY_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/danh-sach-don-theo-don-vi',
    name: 'Xóa đơn trong đơn vị',
    key: 'THAYDOIDONTRONGDONVI_LIETKE'
  }],

  quanLyNguoiDung: [{
    path: '/quan-ly-danh-muc/cong-chuc',
    name: 'Danh sách người dùng',
    key: 'CONGCHUC_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/quoc-tich',
    name: 'Quốc tịch',
    key: 'QUOCTICH_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/dan-toc',
    name: 'Dân tộc',
    key: 'DANTOC_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/chuc-vu',
    name: 'Chức vụ',
    key: 'CHUCVU_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/vai-tro',
    name: 'Nhóm vai trò',
    key: 'VAITRO_LIETKE'
  }],

  cauHinhHeThong: [{
    path: '/quan-ly-danh-muc/tham-so',
    name: 'Tham số',
    key: 'THAMSO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/tu-dong-bao-cao',
    name: 'Cấu hình báo cáo',
    key: 'CAUHINHBAOCAO_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/quan-ly-quy-trinh',
    name: 'Quản lý quy trình',
    key: 'PROCESS_LIETKE'
  }, {
    path: '/quan-ly-danh-muc/cau-hinh-ke-hoach-thanh-tra',
    name: 'Cấu hình kế hoạch thanh tra',
    key: 'CAUHINHKEHOACHTHANHTRA_SUA'
  }],

  thongKeBaoCaoDon: [{
    path: '/thong-ke-bao-cao/tong-hop-tiep-cong-dan',
    name: '2a - Tổng hợp kết quả tiếp công dân',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-xu-ly-don',
    name: '2b - Tổng hợp kết quả xử lý đơn',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-gqd-khieu-nai',
    name: '2c - Tổng hợp kết quả GQD KN',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-gqd-to-cao',
    name: '2d - Tổng hợp kết quả GQD TC',
    key: 'TONGHOPBAOCAO_LIETKE'
  }],

  thongKeBaoCaoThanhTra: [{
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-hanh-chinh',
    name: '[01-TT] Tổng hợp kết quả thanh tra hành chính',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-ket-luan-thanh-tra-hanh-chinh',
    name: '[02-TT] Tổng hợp kết quả thực hiện kết luận thanh tra hành chính',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-xay-dung-co-ban',
    name: '[03-TT] Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đầu tư xây dựng cơ bản',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-tai-chinh',
    name: '[04-TT] Tổng hợp kết quả thanh tra trong lĩnh vực tài chính ngân sách',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-thanh-tra-dat-dai',
    name: '[05-TT] Tổng hợp kết quả thanh tra trong lĩnh vực đất đai',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
    name: '[06-TT] Tổng hợp kết quả thanh tra, kiểm tra chuyên ngành',
    key: 'TONGHOPBAOCAO_LIETKE'
  },{
    path: '/thong-ke-bao-cao/tong-hop-quyet-dinh-xu-phat-qua-thanh-tra-kiem-tra-chuyen-nganh',
    name: '[07-TT] Tổng hợp kết quả thực hiện kết luận, quyết định xử phạt qua thanh tra, kiểm tra chuyên ngành',
    key: 'TONGHOPBAOCAO_LIETKE'
  }],

  baoCaoKiemTra: [{
    path: '/thong-ke-bao-cao/kiem-tra-chi-tiet-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra chi tiết doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/kiem-tra-theo-ke-hoach-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra theo kế hoạch doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/kiem-tra-dot-xuat-doanh-nghiep',
    name: 'Kết quả thanh tra, kiểm tra đột xuất doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }, {
    path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra',
    name: 'Tổng hợp kết quả thanh tra, kiểm tra doanh nghiệp, cơ sở sản xuất kinh doanh',
    key: 'TONGHOPBAOCAO_LIETKE'
  }],
};



// WEBPACK FOOTER //
// ./src/constants/menu-config.js